import React from "react";
import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import { 
  Folder, 
  LocalPharmacy,
  MedicalServices,
  Receipt,
  Payment,
  Schedule,
  MoreHoriz,
  AccountBalance,
  Notifications,
  Assignment
} from "@mui/icons-material";
import { DocumentDto } from "../../api-client";

interface DocumentListItemViewerProps {
  document: DocumentDto;
  index?: number;
  onSelect: (document: DocumentDto) => void;
  selected?: boolean;
}

// Function to get the appropriate icon for each document type
const getDocumentIcon = (docType: string) => {
  switch (docType) {
    case "Rezept":
      return <LocalPharmacy />;
    case "Medizinisch":
      return <MedicalServices />;
    case "Rechnung":
      return <Receipt />;
    case "Quittung":
      return <Payment />;
    case "Termine":
      return <Schedule />;
    case "Sonstiges":
      return <MoreHoriz />;
    case "Mandat":
      return <AccountBalance />;
    case "Mitteilung":
      return <Notifications />;
    case "Arztbericht":
      return <Assignment />;
    default:
      return <Folder />;
  }
};

export const DocumentListItemViewer: React.FC<DocumentListItemViewerProps> = ({
  document,
  index,
  onSelect,
  selected = false,
}) => {
  // Format creation date
  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('de-DE');
  };

  const fileName = document.label || document.name?.split('/').pop() || '';
  const creationDate = formatDate(document.createdAt);
  const secondaryText = creationDate ? `${creationDate} • ${fileName}` : fileName;
  return (
    <ListItem key={document.id || index} disablePadding>
      <ListItemButton
        onClick={() => onSelect(document)}
        selected={selected}
      >
        <ListItemAvatar>
          <Avatar>
            {getDocumentIcon(document.docuType)}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={document.docuType}
          secondary={secondaryText}
          primaryTypographyProps={{
            style: {
              fontSize: '14px',
              fontWeight: selected ? 600 : 400,
            },
          }}
          secondaryTypographyProps={{
            style: { 
              fontSize: '12px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            },
          }}
          sx={{ 
            flex: 1,
            minWidth: 0,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default DocumentListItemViewer;
